import React, { Suspense, lazy, useLayoutEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LoginForm from "./HighwatchAunthentication/LoginForm";
import RegisterForm from "./HighwatchAunthentication/RegisterForm";
import ForgotPassword from "./HighwatchAunthentication/ForgetPasswordForm";
import CheckEmail from "./HighwatchAunthentication/CheckEmail";
import VerifyEmail from "./HighwatchAunthentication/VerifyEmail";
import RegisterDetails from "./HighwatchAunthentication/RegisterAccountDetails";
import CreateNewPassword from "./HighwatchAunthentication/CreateNewPassword";
import PasswordSuccess from "./HighwatchAunthentication/PasswordSuccess";
import ResetVerifyCode from "./HighwatchAunthentication/ResetVerifyCode";
import ChangePassword from "./HighwatchAunthentication/ChangePassword";
import Overview from "./HighwatchDashboard/pages/Overview";
import Settings from "./HighwatchDashboard/pages/Settings";
import AddConnector from "./HighwatchDashboard/pages/AddConnector";
import ConnectorDetail from "./HighwatchDashboard/pages/ConnectorDetail";
import SyncHistory from "./HighwatchDashboard/pages/SyncHistory";
import { abortPendingRequests } from "./api/apiClientFactory";
const Accuracy = lazy(() => import("./HighwatchDashboard/pages/Accuracy"));
const Insights = lazy(() => import("./HighwatchDashboard/pages/Insights"));
const Infrastructure = lazy(() => import("./HighwatchDashboard/pages/Infrastructure"));
const Profile = lazy(() => import("./HighwatchAunthentication/Profile"));
const IngestionPage = lazy(() => import("./HighwatchDashboard/IngestionPage/IngestionPage"));
const ChatBotPage = lazy(() => import("./HighwatchChat/pages/ChatBotPage"));
const MfaSetup = lazy(() => import("./HighwatchDashboard/Security/MfaSetup"));

function PendingRequestJanitor() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  useLayoutEffect(() => {
    if (prevPath.current !== pathname) {
      abortPendingRequests();
      prevPath.current = pathname;
    }
  }, [pathname]);
  return null;
}

export default function RoutesComponent() {
  return (
    <Router>
      <PendingRequestJanitor />
      <Suspense fallback={<div className="p-6 text-sm text-gray-500">Loading…</div>}>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/check-email" element={<CheckEmail />} />
          <Route path="/reset-verify" element={<ResetVerifyCode />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/register-details" element={<RegisterDetails />} />
          <Route path="/create-new-password" element={<CreateNewPassword />} />
          <Route path="/password-success" element={<PasswordSuccess />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/accuracy" element={<Accuracy />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/add-connector" element={<AddConnector />} />
          <Route path="/settings/connectors/:id" element={<ConnectorDetail />} />
          <Route path="/settings/sync-history" element={<SyncHistory />} />
          <Route path="/settings/security/mfa-setup" element={<MfaSetup />} />
          <Route path="/chat/*" element={<ChatBotPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/ingestion" element={<IngestionPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
